import { call, put } from 'redux-saga/effects'
import { baseFetchToken } from './BaseSaga'
import CouponActions from '../Redux/CouponRedux'
import AuthActions from '../Redux/AuthRedux'
import { getToken } from '../Services/GetToken'

export function * getAllCoupon (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getAllCoupon, token, action.data)
      if (!res.ok) {
        yield put(CouponActions.couponFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const DATA_WITH_PAGE = {
            data: res.data.data,
            page,
            total
          }
          yield put(CouponActions.couponSuccess(DATA_WITH_PAGE))
        } else {
          yield put(CouponActions.couponFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(CouponActions.couponFailure())
  }
}

export function * getAllCouponTag (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getAllCouponTag, token, action.data)
      if (!res.ok) {
        yield put(CouponActions.couponTagFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const data_with_page = {
            data: res.data.data,
            page,
            total
          }
          yield put(CouponActions.couponTagSuccess(data_with_page))
        } else {
          yield put(CouponActions.couponTagFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(CouponActions.couponTagFailure())
  }
}

export function * getCouponDetail (api, action) {
  yield baseFetchToken(api.getCouponDetail,
    action.data,
    getToken,
    CouponActions.couponDetailSuccess,
    CouponActions.couponDetailFailure)
}

export function * createNewCoupon (api, action) {
  yield baseFetchToken(api.createNewCoupon,
    action.data,
    getToken,
    CouponActions.couponCreateSuccess,
    CouponActions.couponCreateFailure)
}

export function * generateCoupon (api, action) {
  yield baseFetchToken(api.generateCoupon,
    action.data,
    getToken,
    CouponActions.couponGenerateSuccess,
    CouponActions.couponGenerateFailure)
}

export function * updateCoupon (api, action) {
  yield baseFetchToken(api.updateCoupon,
    action.data,
    getToken,
    CouponActions.couponUpdateSuccess,
    CouponActions.couponUpdateFailure)
}

export function * updateBusiness (api, action) {
  yield baseFetchToken(
    api.updateBusiness,
    action.data,
    getToken,
    CouponActions.businessUpdateSuccess,
    CouponActions.businessUpdateFailure
  )
}

export function * deleteCoupon (api, action) {
  yield baseFetchToken(api.deleteCoupon,
    action.id,
    getToken,
    CouponActions.couponDeleteSuccess,
    CouponActions.couponDeleteFailure)
}

export function * deleteBusiness (api, action) {
  yield baseFetchToken(
    api.deleteBusiness,
    action.id,
    getToken,
    CouponActions.businessDeleteSuccess,
    CouponActions.businessDeleteFailure
  )
}

export function * couponSpreadsheet (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.couponSpreadsheet, token, action.data)
      if (!res.ok) {
        yield put(CouponActions.couponSpreadsheetFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          yield put(CouponActions.couponSpreadsheetSuccess(res.data))
        } else {
          yield put(CouponActions.couponSpreadsheetFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(CouponActions.couponSpreadsheetFailure())
  }
}

export function * historySpreadsheet (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.historySpreadsheet, token, action.data)
      if (!res.ok) {
        yield put(CouponActions.historySpreadsheetFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          yield put(CouponActions.historySpreadsheetSuccess(res.data))
        } else {
          yield put(CouponActions.couponCreateFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(CouponActions.historySpreadsheetFailure())
  }
}

export function * getCouponItem (api, action) {
  yield baseFetchToken(
    api.getCouponItem,
    action.data,
    getToken,
    CouponActions.getCouponItemSuccess,
    CouponActions.getCouponItemFailure
  )
}

export function * postCouponItem (api, action) {
  yield baseFetchToken(
    api.postCouponItem,
    action.data,
    getToken,
    CouponActions.postCouponItemSuccess,
    CouponActions.postCouponItemFailure
  )
}

export function * postCouponItemTag (api, action) {
  yield baseFetchToken(
    api.postCouponItemTag,
    action.data,
    getToken,
    CouponActions.postCouponItemTagSuccess,
    CouponActions.postCouponItemTagFailure
  )
}

export function * deleteCouponItem (api, action) {
  yield baseFetchToken(
    api.deleteCouponItem,
    action.data,
    getToken,
    CouponActions.deleteCouponItemSuccess,
    CouponActions.deleteCouponItemFailure
  )
}

export function * deleteCouponItemTag (api, action) {
  yield baseFetchToken(
    api.deleteCouponItemTag,
    action.data,
    getToken,
    CouponActions.deleteCouponItemTagSuccess,
    CouponActions.deleteCouponItemTagFailure
  )
}

export function * getAffiliates (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getAffiliates, token, action.data)
      if (!res.ok) {
        yield put(CouponActions.getAffiliatesFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const DATA_WITH_PAGE = {
            data: res.data.data,
            page,
            total
          }
          yield put(CouponActions.getAffiliatesSuccess(DATA_WITH_PAGE))
        } else {
          yield put(CouponActions.getAffiliatesFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(CouponActions.getAffiliatesFailure())
  }
}

export function * affiliateTransfer (api, action) {
  yield baseFetchToken(
    api.affiliateTransfer,
    action.data,
    getToken,
    CouponActions.affiliateTransferSuccess,
    CouponActions.affiliateTransferFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/CouponSagas.js